// @flow

import React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import EmailIcon from '@mui/icons-material/Email';

import withStyles from '../utils/withStyles';
import styles from './Styles/SupportDialog.Style';

type Props = {
  classes: Object,
  setOpen: Function,
  open: boolean
};

const videoLinks = [
  { label: 'Full AskNeo Demo', url: 'https://youtu.be/TvX9c3up8OM' },
  { label: 'SMS Automations', url: 'https://youtu.be/pgE6syFx84w' },
  { label: 'Segmentation & Tags', url: 'https://youtu.be/EuyGhBriInI' },
  { label: 'SMS Scripts', url: 'https://youtu.be/m1haFx9-mKo' },
];

// eslint-disable-next-line react/no-multi-comp
const DisplaySupport = (props: Props) => {
  const {
    classes,
    setOpen,
    open
  } = props;

  return (
    <Dialog
      aria-labelledby='form-add-unit'
      onClose={() => setOpen(false)}
      open={open}
    >
        <DialogTitle>{"We're here to help"}</DialogTitle>
        <DialogContent
          classes={{
            root: classes.dialogCtr
          }}
        >
            <List disablePadding>
              {videoLinks.map(({ label, url }) => (
                <a
                  key={label}
                  href={url}
                  rel="noopener noreferrer"
                  target="_blank"
                  className={classes.link}
                >
                  <ListItemButton>
                    <ListItemIcon>
                      <OndemandVideoIcon />
                    </ListItemIcon>
                    <ListItemText primary={label} />
                    <OpenInNewIcon fontSize="small" />
                  </ListItemButton>
                </a>
              ))}
            </List>
            <Divider sx={{ mt: 2 }} />
            <List disablePadding>
              <a
                href="mailto:hello@askneo.io"
                className={classes.link}
              >
                <ListItemButton>
                  <ListItemIcon>
                    <EmailIcon />
                  </ListItemIcon>
                  <ListItemText primary="Contact Support" secondary="hello@askneo.io" />
                </ListItemButton>
              </a>
            </List>
        </DialogContent>
    </Dialog>
  );
};

export default withStyles(styles)(DisplaySupport);
